const states = {
    botmessage_details: {
        bot_messages: [],
        bot_messages_schema: {},
        bot_messages_ui_schema: {},
        context_variables_data: {},
        message_form_data: {},
        loaders: {
            bot_messages_loading: false,
            bot_messages_loaded: false,
            bot_message_updating: false,
        }
    }
};

export default states;


// WEBPACK FOOTER //
// ./src/data/redux/botmessage_details/states.js